import { render } from "./ub-color.vue?vue&type=template&id=bb98b214&scoped=true"
import script from "./ub-color.vue?vue&type=script&lang=js"
export * from "./ub-color.vue?vue&type=script&lang=js"

import "./ub-color.vue?vue&type=style&index=0&id=bb98b214&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb98b214"]])

export default __exports__